import { dateTimeRange } from '../../shared/dateTime';

/**
 * Termin punktu trasy z planu TMS (`router_order_planned_date_*`).
 *
 * Okno klienta (`customer_*`) jest jedno na całe zlecenie — identyczne na
 * każdym punkcie (sprawdzone 28.09.2026 na 16,9 tys. zleceń), więc przy
 * punkcie nic nie mówi. Termin punktu niesie tylko plan: przy zleceniu
 * nieobsadzonym równy krańcom okna klienta, po obsadzeniu przestawiany przez
 * planistę; bywa momentem, bywa przedziałem (np. 08–15).
 *
 * Bez sekund, a przedział w obrębie jednego dnia bez powtórzonej daty
 * („29.09.2026, 08:00–15:00”) — dwie pełne daty z sekundami łamały kolumnę
 * na cztery linie, a plan TMS sekund i tak nie ma. Zapis przedziału jest
 * wspólny z podglądem oferty giełdowej (`dateTimeRange`, 30.09.2026).
 */
export function pointTimeText(from?: string | null, to?: string | null): string {
  return dateTimeRange(from, to);
}
